export default __webpack_public_path__ + "static/media/news68.8a756f3a.jpg";